// src/api/axiosClient.js
import axios from 'axios';

const axiosClient = axios.create({
  baseURL: 'https://stockarchives-api.com', // Base URL of your FastAPI backend
  //baseURL:'http://127.0.0.1:8000',
  timeout: 10000, // 10 seconds
  headers: {
    'Content-Type': 'application/json',
    // Add authorization headers here if needed
  }
});

// Optional: Interceptors for request/response logging or token handling
axiosClient.interceptors.response.use(
  response => response,
  error => {
    console.error('API Error:', error.response || error.message);
    return Promise.reject(error);
  }
);

export default axiosClient;